const dangerousCharacters = new RegExp('[`!^+()~{}/"=\\\\]');
const letters = new RegExp("^(?=.*[a-zA-Z])");
const lowerCase = new RegExp("^(?=.*[a-z])");
const number = new RegExp("^(?=.*[0-9])");
const period = new RegExp("^(?=.*[.])");
const phone = new RegExp("[0-9()-]?");
const special = new RegExp("^[.]");
const upperCase = new RegExp("^(?=.*[A-Z])");

export const emailRules = email => {
  return {
    firstNotSpecial: email => !special.test(email),
    hasPeriod: email => period.test(email),
    isNotEmpty: email => email !== ""
  };
};

export const nameRules = name => {
  return {
    dangerChar: name => !dangerousCharacters.test(name)
  };
};

export const passwordRules = (password, email) => {
  return {
    isNotEmail: password => password !== email,
    passwordLength: password => password.length > 7,
    hasLowerCase: password => lowerCase.test(password),
    hasUpperCase: password => upperCase.test(password),
    hasNumber: password => number.test(password)
  };
};

export const passwordConfirmRules = (password, passwordConfirm) => {
  return {
    passwordsMatch: passwordConfirm => passwordConfirm === password
  };
};

export const phoneRules = tel => {
  return {
    telChar: tel => phone.test(tel),
    noLetters: tel => !letters.test(tel),
    noDangerouCharacters: tel => !dangerousCharacters.test(tel)
  };
};

export const phoneParser = value => {
  let x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  return !x[2] ? x[1] : "" + x[1] + " " + x[2] + (x[3] ? " " + x[3] : "");
};

//Form-wide rules
export const loginFormRules = (email, password, dbErrors) => {
  return {
    "": {
      userNotFound: () => dbErrors !== "userNotFound",
      incorrectPassword: () => dbErrors !== "incorrectPassword"
    }
  };
};

export const signUpFormRules = (email, password, passwordConfirm, dbErrors) => {
  return {
    "": {
      emailAlreadyTaken: () => dbErrors !== "emailAlreadyTaken",
      hasLowerCase: () => lowerCase.test(password),
      hasNumber: () => number.test(password),
      hasUpperCase: () => upperCase.test(password),
      isNotEmail: () => password !== email,
      passwordLength: () => password.length > 7,
      passwordsMatch: () => password === passwordConfirm
    }
  };
};



// WEBPACK FOOTER //
// ./src/util/validate.js